import React from "react";
import { Col, Row } from "react-bootstrap";

import { Button, Skeleton } from "components";
import { useLoader } from "hooks";

import { ReactComponent as EditIcon } from "static/images/pencil.svg";
import styles from "./editableField.module.scss";

type EditableFieldProps = {
	isLoading: boolean;
	label: string;
	colLabel: number;
	colValue: number;
	value: string;
	onClick: Function;
};

const EditableField = ({
	isLoading,
	label,
	colLabel,
	colValue,
	value,
	onClick,
}: EditableFieldProps) => {
	const Loader = useLoader(isLoading);
	return (
		<Loader
			skeleton={<Skeleton height={34} />}
			component={
				<Row>
					<Col sm={colLabel}>{label}</Col>
					<Col sm={colValue} className={styles.editableValueHolder}>
						<div>{value}</div>
						<Button
							onClick={onClick}
							icon={<EditIcon />}
							btnIcon
							variant="secondary"
							size="sm"
							className={styles.editableBtn}
						/>
					</Col>
				</Row>
			}
		/>
	);
};

export default EditableField;
